export const ACTIVE_IMAGE_CHANGE = 'ACTIVE_IMAGE_CHANGE';

export const onActiveImageChanged = (imageType) => {
    return {
        type: ACTIVE_IMAGE_CHANGE,
        imageType,
    };
};

export const NEW_IMAGE = 'NEW_IMAGE';

export const onNewImage = (image) => {
    return {type: NEW_IMAGE, image};
};



// WEBPACK FOOTER //
// ./src/actions/EditorActions.js